import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsEsSend } from '@skynet/data-ws-es';
import type { DexTradingAddPayload } from 'src/store/trading/dex/types';
import { DexTradingApiCommands } from 'src/store/trading/dex/types';

export const addEsDexPair = createAppAsyncThunk(
  'tradingApiKeys/addDexPair',
  (data: DexTradingAddPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: DexTradingApiCommands.AddESDEXPair,
        ...data,
      }),
    ),
);

export const deleteEsDexPair = createAppAsyncThunk(
  'tradingApiKeys/deleteDexPair',
  (accountID: number, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: DexTradingApiCommands.DeleteESDEXPair,
        accountID,
      }),
    ),
);
